module.exports = __webpack_public_path__ + "static/media/c-more-sport-2.a2182f11.png";